import CommonState from '@/class/cargo/model/parameters/CommonState'

/**
 * 进仓照片
 */
export const WAREHOUSE_PIC = 100

/**
 * 打板照片
 */
export const LOADING_PIC = 101

/**
 * 报关文件
 */
export const UPLOAD_CS_FILE = 1000

/**
 * 退单
 */
export const UPLOAD_ORDER_BACK = 1001

/**
 * 托书
 */
export const SHIPPING_ORDER = new CommonState('shippingOrder', '托书', 'Shipping Order')

/**
 * 进仓单
 */
export const DELIVERY_NOTE = new CommonState('deliveryNote', '进仓单', 'Delivery Note')

/**
 * 订舱单
 */
export const BOOKING_ORDER = new CommonState('bookingOrder', '订舱单', 'Booking Order')

/**
 * 运单
 */
export const BILL = new CommonState('bill', '运单', 'Bill')

/**
 * 费用确认单
 */
export const CHARGE_CONFIRM_BILL = new CommonState('chargeConfirmBill', '费用确认单', 'Confirm Bill')

/**
 * 海外账单
 */
export const OVERSEA_BILL = new CommonState('overseaBill', '海外账单', 'OverSea Bill')

/**
 * POD
 */
export const POD = new CommonState('pod', '进仓单', 'pod')

/**
 * 报关文件
 */
export const CS_FILE = new CommonState('csFile', '报关文件', 'Customs Declaration File')

/**
 * 预录单
 */
export const PRE_RECORDED_BILL = new CommonState('preRecordedBill', '预录单', 'Pre Recoreded Bill')

/**
 * 往来邮件
 */
export const MAIL = new CommonState('mail', '往来邮件', 'Mail')

/**
 * 目的港到货清单
 */
export const POD_ARRIVAL_LIST = new CommonState('podArrivalList', 'POD', 'POD Arrival List')

/**
 * 情况说明
 */
export const FACT_SHEETS = new CommonState('fSheets', '情况说明', 'Fact Sheets')

/**
 * 化工鉴定
 */
export const CHEMOCAL_IDENT = new CommonState('CI', '化工鉴定', 'Chemical identification')

/**
 * 磁检报告
 */
export const M_I_R = new CommonState('MIR', '磁检报告', 'Magnetic inspection report')

/**
 * 舱单
 */
export const MANIFEST = new CommonState('MF', '舱单', 'Manifest')

/**
 * 退单
 */
export const ORDER_BACK = new CommonState('Oback', '退单', 'Orderback')

/**
 * 预报
 */
export const FORECAST = new CommonState('Forecast', '预报', 'Forecast')

/**
 * 提货单
 */
export const MBL = new CommonState('MBL', '提货单', 'MBL')

/**
 * 清关文件
 */
export const CLEAR_DOC = new CommonState('ClearDoc', '清关文件', 'Clearance Documents')

/**
 * 其它
 */
export const OTHER = new CommonState('other', '其它', 'Other')

/**
 * 整箱运价
 */
export const PRICE_FCL = new CommonState(200, '整箱运价导入文档', 'Import FCL File')

/**
 * 拼箱运价
 */
export const PRICE_LCL = new CommonState(201, '拼箱运价导入文档', 'Import LCL File')

export const KEF_EXPORT = new CommonState(8001, 'KEF 导出文档', 'KEF Export File')
export const KEF_IMPORT = new CommonState(8002, 'KEF 导入文档', 'KEF ImportFile')

export const SEA_EXPORT = new CommonState(9001, '海运出口订单导入文档', 'Shipping export order import document')
export const SEA_IMPORT = new CommonState(9002, '海运进口订单导入文档', 'Shipping import order import document')
export const AIR_EXPORT = new CommonState(9003, '空运出口订单导入文档', 'Air transport export order import document')
export const AIR_IMPORT = new CommonState(9004, '空运进口订单导入文档', 'Air transport import order import document')
export const RAILWAY_EXPORT = new CommonState(9005, '铁路出口订单导入文档', 'Railway export order import document')
export const RAILWAY_IMPORT = new CommonState(9006, '铁路进口订单导入文档', 'Railway import order import document')
export const BATCH_CUSTOM_DOOR_POINT_IMPORT = new CommonState(9013, '客户门点-多柜装箱信息导入', 'Customer door point multi cabinet packing import')
export const SINGLE_FBA_JOB = new CommonState(9010, '单个FBA订单导入文档', 'Single FBA order import document')
export const FBA_BATCH_IMPORT_GOODS = new CommonState(9007, '货物信息明细导入（国内仓）', 'Goods Info Detail Import Domestic Warehouse')
export const FBA_BATCH_IMPORT_GOODS_FBA = new CommonState(9008, '货物信息明细导入（FBA）', 'Goods Info Detail Import FBA')
export const BA_BATCH_IMPORT_GOODS_OSUMMARY_FBA = new CommonState(9009, '货物信息汇总导入（FBA）', 'Goods Info Detail Import FBA On Order')
export const FBA_BATCH_IMPORT_GOODS_SUMMARY = new CommonState(9011, '货物信息汇总导入（国内仓）', 'Goods Info Detail Import Domestic Warehouse')
export const BATCH_FBA_JOB_IMPORT = new CommonState(9012, 'FBA批量订单导入', 'batch FBA Order File Import')
export const BATCH_SEA_JOB_IMPORT = new CommonState(9015, '海运头程-批量订单', 'batch Sea Fist File Import')
export const SIMPLE_SEA_JOB_IMPORT = new CommonState(9014, '海运头程-单个订单', 'simple Sea Fist File Import')
export const SINGLE_FBA_AIR_JOB_IMPORT = new CommonState(9016, '空运头程-单个订单', 'Single Fba Air Job Import')
export const BATCH_FBA_AIR_JOB_IMPORT = new CommonState(9017, '空运头程-批量订单', 'Batch Fba Air Job Import')
export const PARTNER_INFO_IMPORT = new CommonState(9020, '合作伙伴信息导入', 'Partner information import')
export const USER_IMPORT = new CommonState(9021, '用户管理导入文档', 'User management import document')
export const SINGLE_FBA_RAILWAY_JOB_IMPORT = new CommonState(9018, '铁路头程-单个订单', 'Single Fba Railway Job Import')
export const BATCH_FBA_RAILWAY_JOB_IMPORT = new CommonState(9019, '铁路头程-批量订单', 'Batch Fba Railway Job Import')
export const VGM_IMPORT = new CommonState(9023, 'VGM导入文档', 'VGM Import File')
export const FBA_QUOTATION_IMPORT = new CommonState(9022, 'FBA报价单导入文档', 'Fba quotation import document')
export const INVOICE_QD = new CommonState(9024, '全电发票', 'Invoice File')

export const AE_MAWB_IMPORT = new CommonState(9025, '空出主单导入文档', 'AE MAWB Import File')
export const INSURANCE_DOCUMENTS = new CommonState(9026, '投保文件', 'Insurance Documents')
export const POLICY_DOWNLOAD = new CommonState(9027, '保单下载记录', 'Policy Download Record')
export const PILL_ACCRUE_REPORT = new CommonState(9029, 'Accrue Report', 'Accrue Report')
export const PILL_ACCRUE_MONITOR = new CommonState(9030, 'Accrue Monitor', 'Accrue Monitor')
export const PILL_HR_GP_REPORT = new CommonState(9031, 'HR GP Report', 'HR GP Report')
export const AE_UNIT_LOAD_IMPORT = new CommonState(9032, '空运出口集装器导入', 'AE unit load Import')
export const PILL_EXPORT_ACTUALAMOUNT = new CommonState(9033, '导出Accpac销账数据', 'Export Accpac Writeoff Data')
export const PILL_EXPORT_INVOICE = new CommonState(9034, '导出Accpac发票数据', 'Export Accpac Invoice Data')
export const PILL_EXPORT_BILLING = new CommonState(9035, '导出Accpac海外账单数据', 'Export Accpac Overseas Billing Data')
export const INVOICE_OJ = new CommonState(9224, '蓝票发票号导入文档', 'Invoice No Import File')

export const EDI_BOOKING_RECEIPT = new CommonState(9100, 'EDI订舱回执记录', 'EDI Booking Receipt Record')

export const VESSEL_SCHEDULE_RECEIPT = new CommonState(9101, '船期回执记录', 'Vessel Schedule Receipt Record')

// 批量打印节点
export const BATCH_PRINT_SE = new CommonState(1, '海运订舱批量打印 ', '海运订舱批量打印 ')
export const BATCH_PRINT_SI = new CommonState(2, '海运操作批量打印 ', '海运操作批量打印 ')
export const BATCH_PRINT_AE = new CommonState(3, '空运订舱批量打印 ', '空运订舱批量打印 ')
export const BATCH_PRINT_AI = new CommonState(4, '空运操作批量打印 ', '空运操作批量打印 ')
export const BATCH_PRINT_RE = new CommonState(5, '铁路操作批量打印 ', '铁路操作批量打印 ')
export const BATCH_PRINT_CWSH = new CommonState(6, '财务审核打印 ', '财务审核打印 ')
export const BATCH_PRINT_ZD = new CommonState(7, '对账新版-账单打印 ', '对账新版-账单打印 ')
export const BATCH_PRINT_DZD = new CommonState(8, '对账新版-对账单打印 ', '对账新版-对账单打印 ')
export const BATCH_PRINT_FP = new CommonState(9, '发票查询打印 ', '发票查询打印 ')
export const BATCH_PRINT_FKSQ = new CommonState(10, '付款申请打印 ', '付款申请打印 ')
export const BATCH_PRINT_JCGL = new CommonState(11, '进仓管理打印 ', '进仓管理打印')
export const BATCH_PRINT_CWZH = new CommonState(12, '财务综合查询打印 ', '财务综合查询打印 ')
export const BATCH_PRINT_IE = new CommonState(13, '综合物流批量打印 ', '综合物流批量打印 ')

export const BUSINESS_BILL_PRINT = new CommonState(20, '业务模块-账单打印', 'Business Module - Bill Print')

export const PARTNER_SUPPLY_CHAIN_ROUTE_IMPORT = new CommonState(9201, '合作伙伴-供应链线路导入', 'Partner - Supply chain route import')
export const COST_EXCHANGE_RATE_IMPORT = new CommonState(9202, '汇率管理-费用汇率导入', 'Exchange rate Management - Cost exchange rate import')
export const AIR_FREIGHT_IMPORT = new CommonState(9203, '空运运价输入导入', 'Import of air freight')
export const SALE_CUSTOMER_IMPORT = new CommonState(9204, '销售-我的客户导入', 'Sale customer import')
export const MANIFESTINFO_IMPORT = new CommonState(9205, '预配舱单导入', 'ManifestInfo import')
export const DOCUMENT_IMPORT = new CommonState(9206, '托书导入', 'Document import')
export const BILL_IMPORT = new CommonState(9207, '提单导入', 'Bill import')
export const DOC_IMPORT = new CommonState(9208, '对单导入', 'Doc import')
export const CONTENTDESCRIPTION_IMPORT = new CommonState(9209, '货物明细导入', 'ContentDescription import')
export const VESSEL_VOYAGE_MSC_IMPORT = new CommonState(9210, '船名航次MSC导入', 'Vessel voyage msc import')
export const BATCH_FEE_IMPORT = new CommonState(9211, '费用批量导入', 'Batch fee import')
export const BATCH_FEE_IMPORT_RESULT = new CommonState(9212, '费用批量导入结果', 'Batch fee import result')
export const SE_CONTAINER_USAGE_IMPORT = new CommonState(9213, '海出装箱信息导入', 'SE container usage import')
export const SI_CONTAINER_USAGE_IMPORT = new CommonState(9214, '海进装箱信息导入', 'SI container usage import')
export const RE_CONTAINER_USAGE_IMPORT = new CommonState(9215, '铁出装箱信息导入', 'RE container usage import')
export const RI_CONTAINER_USAGE_IMPORT = new CommonState(9216, '铁进装箱信息导入', 'RI container usage import')
export const SI_CSV_IMPORT = new CommonState(9217, '海进支付信息导入', 'SI csv import')
export const AI_IATA_FREIGHT_IMPORT = new CommonState(9218, '空进IATA运价导入', 'AI IATA freight import')
export const AI_CSV_IMPORT = new CommonState(9219, '空进支付信息导入', 'AI csv import')
export const BILL_NUMBER_IMPORT_QUERY = new CommonState(9220, '账单号导入查询', 'Bill number Import query')
export const FINANCE_CODE_MAPPING_PARTNER_IMPORT = new CommonState(9221, '财务管理编码映射合作伙伴导入', 'finance code mapping partner import')
export const FINANCE_CODE_MAPPING_AR_INVOICE_TITLE_IMPORT = new CommonState(9222, '财务管理编码映射应收发票抬头导入', 'finance code mapping ar invoice title import')
export const SE_CABIN_MANAGEMENT_IMPORT = new CommonState(9323, '海运出口舱位导入文档', 'Sea export cabin space import document')
export const BATCH_IMPORT_OF_RECEIPT_WRITE_OFF = new CommonState(9324, '批量导入收款销账', 'Batch import of receipt write-off')
export const BATCH_IMPORT_OF_PAYMENT_WRITE_OFF = new CommonState(9325, '批量导入付款销账', 'Batch import of payment write-off')
export const LOCATION_CONFIGURATION_IMPORT = new CommonState(9334, '库位导入', 'Storage location import')
export const PALLET_IMPORT = new CommonState(9335, '托盘导入', 'Pallet import')
export const CUSTOMER_CHANGE_LOG = new CommonState(9326, '委托单位变更日志报表', 'Entrust the organization to change the log report')
export const SINGLE_TICKET_GUARANTEE_NORMAL = new CommonState(9327, '单票保函-普通', 'Single ticket guarantee normal')
export const SINGLE_TICKET_GUARANTEE_SPLIT = new CommonState(9328, '单票保函-拆单', 'Single ticket guarantee split')
export const SINGLE_TICKET_GUARANTEE_MERGE = new CommonState(9329, '单票保函-并单', 'Single ticket guarantee merge')
export const ASSEMBLY_PLAN_IMPORT = new CommonState(9400, '拼装计划导入', 'Assembly plan import')
export const OPEN_PRICE_MANUALLY_EXPORT_FILE = new CommonState(9401, '航交所运价手动导出文件', 'Manually Export File')
export const OPEN_PRICE_IMPORT_FINAL_RESULT = new CommonState(9402, '航交所运价导入最终结果', 'Import Final Result')
export const SENSITIVE_WORD_IMPORT_FINAL_RESULT = new CommonState(9403, '敏感词导入最终结果', 'Sensitive Word Import Final Result')

export const DOCUMENT_CATEGORY_PRICE = [PRICE_FCL, PRICE_LCL, KEF_EXPORT, KEF_IMPORT, SEA_EXPORT, SEA_IMPORT, AIR_EXPORT, AIR_IMPORT, RAILWAY_EXPORT, RAILWAY_IMPORT, BATCH_PRINT_SE, BATCH_PRINT_SI, BATCH_PRINT_AE, BATCH_PRINT_AI, BATCH_PRINT_RE, BATCH_PRINT_CWSH, BATCH_PRINT_ZD, BATCH_PRINT_DZD, BATCH_PRINT_FP, BATCH_PRINT_FKSQ, BATCH_PRINT_JCGL, BATCH_PRINT_CWZH, BATCH_CUSTOM_DOOR_POINT_IMPORT, BATCH_PRINT_IE, BUSINESS_BILL_PRINT, SINGLE_FBA_JOB, FBA_BATCH_IMPORT_GOODS, FBA_BATCH_IMPORT_GOODS_FBA, BA_BATCH_IMPORT_GOODS_OSUMMARY_FBA, FBA_BATCH_IMPORT_GOODS_SUMMARY, BATCH_FBA_JOB_IMPORT, BATCH_SEA_JOB_IMPORT, SIMPLE_SEA_JOB_IMPORT, SINGLE_FBA_AIR_JOB_IMPORT, BATCH_FBA_AIR_JOB_IMPORT, PARTNER_INFO_IMPORT, USER_IMPORT, SINGLE_FBA_RAILWAY_JOB_IMPORT, BATCH_FBA_RAILWAY_JOB_IMPORT, FBA_QUOTATION_IMPORT, VGM_IMPORT, INVOICE_QD, INVOICE_OJ, AE_MAWB_IMPORT, INSURANCE_DOCUMENTS, POLICY_DOWNLOAD, PILL_ACCRUE_REPORT, PILL_ACCRUE_MONITOR, PILL_HR_GP_REPORT, PILL_EXPORT_ACTUALAMOUNT, PILL_EXPORT_INVOICE, PILL_EXPORT_BILLING, AE_UNIT_LOAD_IMPORT, EDI_BOOKING_RECEIPT, VESSEL_SCHEDULE_RECEIPT, PARTNER_SUPPLY_CHAIN_ROUTE_IMPORT, COST_EXCHANGE_RATE_IMPORT, AIR_FREIGHT_IMPORT, SALE_CUSTOMER_IMPORT, MANIFESTINFO_IMPORT, DOCUMENT_IMPORT, BILL_IMPORT, DOC_IMPORT, CONTENTDESCRIPTION_IMPORT, VESSEL_VOYAGE_MSC_IMPORT, BATCH_FEE_IMPORT, BATCH_FEE_IMPORT_RESULT, SE_CONTAINER_USAGE_IMPORT, SI_CONTAINER_USAGE_IMPORT, RE_CONTAINER_USAGE_IMPORT, RI_CONTAINER_USAGE_IMPORT, SI_CSV_IMPORT, AI_IATA_FREIGHT_IMPORT, AI_CSV_IMPORT, BILL_NUMBER_IMPORT_QUERY, FINANCE_CODE_MAPPING_PARTNER_IMPORT, FINANCE_CODE_MAPPING_AR_INVOICE_TITLE_IMPORT, SE_CABIN_MANAGEMENT_IMPORT, LOCATION_CONFIGURATION_IMPORT, PALLET_IMPORT, BATCH_IMPORT_OF_RECEIPT_WRITE_OFF, BATCH_IMPORT_OF_PAYMENT_WRITE_OFF, ASSEMBLY_PLAN_IMPORT, OPEN_PRICE_MANUALLY_EXPORT_FILE, OPEN_PRICE_IMPORT_FINAL_RESULT, SENSITIVE_WORD_IMPORT_FINAL_RESULT]
export const DOCUMENT_CATEGORY_PRICE_CODE = [200, 201, 8001, 8002, 9001, 9002, 9003, 9004, 9005, 9006, 9010, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 20, 9007, 9008, 9009, 9011, 9012, 9013, 9014, 9015, 9016, 9017, 9018, 9019, 9020, 9021, 9023, 9024, 9026, 9027,
  9029, 9030, 9031, 9032, 9033, 9034, 9035, 9100, 9101, 9201, 9202, 9203, 9204, 9205, 9206, 9207, 9208, 9209, 9210, 9211, 9212, 9213, 9214, 9215, 9216, 9217, 9218, 9219, 9220, 9221, 9222, 9323, 9224, 9324, 9325, 9334, 9335, 9326, 9327, 9328, 9329, 9401, 9402, 9403]
/**
 * 空运上传文档类型
 */
export const AE_DOCUMENT_TYPES = ([
  BOOKING_ORDER,
  BILL,
  SHIPPING_ORDER,
  CHARGE_CONFIRM_BILL,
  OVERSEA_BILL,
  POD,
  CS_FILE,
  PRE_RECORDED_BILL,
  MAIL,
  POD_ARRIVAL_LIST,
  FACT_SHEETS,
  CHEMOCAL_IDENT,
  M_I_R,
  MANIFEST,
  ORDER_BACK,
  FORECAST,
  MBL,
  CLEAR_DOC,
  OTHER
])

export const SINGLE_TICKET_GUARANTEE_TYPES = ([
  SINGLE_TICKET_GUARANTEE_NORMAL,
  SINGLE_TICKET_GUARANTEE_SPLIT,
  SINGLE_TICKET_GUARANTEE_MERGE
])
